import classNames, { Argument } from 'classnames';
import { Fragment } from 'react';
import { FieldInputProps, FormikProps, getIn } from 'formik';
import FormikErrorMessage from '../error/FormikErrorMessage';
import React from 'react';
import ZenInputText from './ZenInputText';

export interface FormikInputTextProps<T> {
    field: FieldInputProps<string>;
    form: FormikProps<T>;
    className?: Argument[];
    visibleError?: boolean;
}

const FormikInputText = ({
    field,
    form: { touched, errors },
    className,
    visibleError = true,
    ...props
}: FormikInputTextProps<any>) => {
    const isError = () => {
        const error = getIn(errors, field.name);
        const touch = getIn(touched, field.name);
        return touch && error ? error : null;
    };
    const classList = () => {
        return classNames([
            {
                'border-error': isError(),
                'border-grey-light hover:border-info-60': !isError(),
            },
            className,
        ]);
    };
    return (
        <Fragment>
            <ZenInputText className={classList()} {...field} {...props} />
            {visibleError && <FormikErrorMessage name={field.name} />}
        </Fragment>
    );
};

export default FormikInputText;
